import AssignServiceDialog from './AssignServiceDialog';

export default AssignServiceDialog;
